import React from "react";
import PropTypes from "prop-types";

import style from "./SyntaxHighlightStyle.module.css";

/**
 * Apply CSS styles to code that has been converted to syntax-highlighted HTML.
 */
class SyntaxHighlightStyle extends React.Component {
  render() {
    return (
      <div
        className={style.root}
        dangerouslySetInnerHTML={{ __html: this.props.html }}
      />
    );
  }
}
SyntaxHighlightStyle.propTypes = {
  html: PropTypes.string
};
SyntaxHighlightStyle.defaultProps = {
  html: null
};
export default SyntaxHighlightStyle;



// WEBPACK FOOTER //
// ./src/byos/component/SyntaxHighlightStyle.js